import React from 'react';
import {
  FaCompass,
  FaGraduationCap,
  FaMedal,
  FaShieldAlt,
  FaStar,
  FaTrophy
} from 'react-icons/fa';
import { GiDiamonds, GiLaurelCrown, GiEmerald } from 'react-icons/gi';

const BADGE_ICON_MAP = {
  gray_diamond: GiDiamonds,
  compass: FaCompass,
  bronze_badge: FaMedal,
  shield: FaShieldAlt,
  graduation_badge: FaGraduationCap,
  silver_star: FaStar,
  gold_medal: FaMedal,
  emerald_badge: GiEmerald,
  trophy: FaTrophy
};

const BadgeIcon = ({ badgeKey, color = '#9CA3AF', size = 24, className = '' }) => {
  const IconComponent = BADGE_ICON_MAP[badgeKey] || GiLaurelCrown;

  return (
    <span
      className={`inline-flex items-center justify-center rounded-xl ${className}`}
      style={{ color }}
      aria-hidden="true"
    >
      <IconComponent size={size} />
    </span>
  );
};

export const getInitials = (firstName = '', lastName = '') => {
  const first = (firstName || '').trim().charAt(0);
  const last = (lastName || '').trim().charAt(0);
  return `${first}${last}`.toUpperCase() || '?';
};

export const LearnerAvatar = ({ avatarPath, firstName, lastName, sizeClass = 'w-12 h-12', uploadsBaseUrl }) => {
  const initials = getInitials(firstName, lastName);

  if (avatarPath && uploadsBaseUrl) {
    const cleanPath = avatarPath.replace(/^\/+/, '');
    return (
      <img
        src={`${uploadsBaseUrl}/${cleanPath}`}
        alt={`${firstName || ''} ${lastName || ''}`.trim()}
        className={`${sizeClass} rounded-full object-cover border-2 border-white shadow`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-gradient-to-br from-purple-500 to-pink-600 text-white flex items-center justify-center font-bold shadow`}
      aria-label={`${firstName || ''} ${lastName || ''}`.trim()}
    >
      {initials}
    </div>
  );
};

export default BadgeIcon;
